<template>
  <div class="title-row" :class="{ 'mobile-column': mobileColumn }">
    <span :style="{width: width + 'ch' }">{{ left }}</span>
    <h1 v-if="titleIsH1">{{ center }}</h1>
    <span v-else>{{ center }}</span>
    <span :style="{width: width + 'ch' }">{{ right }}</span>
  </div>
</template>

<script>
export default {
  name: 'TitleRow',
  props: {
    left: {
      default: ''
    },
    center: {
      default: ''
    },
    right: {
      default: ''
    },
    titleIsH1: {
      default: false
    },
    mobileColumn: {
      default: false
    }
  },
  computed: {
    width () {
      return Math.max(this.left.length, this.right.length) + 1
    }
  }
}
</script>

<style scoped>
.title-row {
  display: flex;
  justify-content: space-between;
  padding: var(--p1);
  font: var(--nord);
  text-align: center;
  text-transform: uppercase;
}

.title-row > span:nth-child(1) { 
  text-align: left;
  /*width: 11rem;*/
}

.title-row > span:nth-child(2) { 
  text-align: center;
  flex: 1;
  padding: 0 1rem 0 1rem;
}

.title-row > span:nth-child(3) { 
  text-align: right;
  /*width: 11rem;*/
}

@media (max-width: 600px) {
  .title-row {
    flex-wrap: wrap;
    justify-content: center;
  }

  .title-row.mobile-column {
    flex-direction: column;
    align-items: center;
  }

  .title-row > span:nth-child(1) { 
    order: 2;
    width: auto!important;
    padding: 0 1rem 0 1rem;
  }

  .title-row > span:nth-child(2) { 
    order: 1;
    width: 100%;
    flex: none;
  }

  .title-row > span:nth-child(3) { 
    order: 3;
    width: auto!important;
    padding: 0 1rem 0 1rem;
  }
}
</style>